import { render, staticRenderFns } from "./BizMonthlyRepayment.vue?vue&type=template&id=71fa2d53&scoped=true"
import script from "./BizMonthlyRepayment.vue?vue&type=script&lang=js"
export * from "./BizMonthlyRepayment.vue?vue&type=script&lang=js"
import style0 from "./BizMonthlyRepayment.vue?vue&type=style&index=0&id=71fa2d53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fa2d53",
  null
  
)

export default component.exports